<template>
  <el-dialog
    title="选择颜色"
    :visible.sync="dialogVisible"
    width="320px"
    :before-close="handleCancel"
    append-to-body
  >
    <div class="color-picker-wrapper">
      <el-color-picker
        v-model="selectedColor"
        :show-alpha="false"
        color-format="hex"
        size="medium"
      />
      <div class="color-preview-row">
        <span class="preview-label">当前颜色：</span>
        <div
          class="color-preview"
          :style="{ backgroundColor: selectedColor }"
        ></div>
        <span class="color-value">{{ selectedColor }}</span>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "#FF0000",
    },
  },
  data() {
    return {
      selectedColor: "#FF0000",
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedColor = this.value || "#FF0000";
      }
    },
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm", this.selectedColor);
      this.$emit("update:visible", false);
    },
    handleCancel() {
      this.$emit("cancel");
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.color-picker-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.color-preview-row {
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
}

.preview-label {
  font-size: 14px;
  color: #666;
}

.color-preview {
  width: 40px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.color-value {
  font-size: 14px;
  color: #333;
  font-family: monospace;
}

.dialog-footer {
  text-align: right;
}
</style>
